import { render, staticRenderFns } from "./google-home.vue?vue&type=template&id=46e47c2e&"
import script from "./google-home.vue?vue&type=script&lang=js&"
export * from "./google-home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports